import React, { forwardRef } from "react"
import { classNames } from "../../utils"
import { Block, BlockProps } from "../Block"

export type FlexProps = BlockProps

export const Flex = forwardRef<HTMLDivElement, FlexProps>(function Flex(
  { className, ...rest },
  ref,
) {
  return <Block className={classNames("flex", className)} ref={ref} {...rest} />
})
